<button 
  matRipple
  class="py-2.5 px-4 rounded-[20px] border leading-4 font-montserrat border-lime-regular {{ class }}">
  {{ label }}
</button>
